import lodash from 'lodash'
import { createLoading } from "../../../../../../utils/loading";
import { createPage } from "../../../../../../utils/page";

export const { isLoading, setIsLoading } = createLoading()

export const initData = ({ props, data }) => {
  const { itemsKey } = props;
  const { useForm } = data;
  const { modelRef } = useForm;
  const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
  data.page = createPage({ data: items });
};